import type { ProductVariant } from '~~/types/commercetools';
import { centAmountToNormalPrice } from '~~/helpers/cart/getTotalPricesModule';
import { PRICE_CUSTOM_FIELDS } from '~~/constants/commerceTools';

export const getDiscountedPrice = (product: ProductVariant): number | null => {

  return centAmountToNormalPrice(product?.price?.discounted?.value?.centAmount);

};
export const getFullProductPrice = (product: ProductVariant): number | null => {

  return centAmountToNormalPrice(product?.price?.value?.centAmount);

};

export const getFinalPriceFromAmounts = (
  discountedPrice?: number | null, fullProductPrice?: number | null,
): number | null => {

  return discountedPrice ?? fullProductPrice ?? null;

};

export const getFinalPrice = (product: ProductVariant): number | null => {

  return getFinalPriceFromAmounts(getDiscountedPrice(product), getFullProductPrice(product));

};

export const getLast30DaysPrice = (product: ProductVariant): number | null => {

  const last30DaysCentAmount = product?.price?.custom?.customFieldsRaw?.find(
    field => field.name === PRICE_CUSTOM_FIELDS.LAST_30_DAYS_PRICE_CUSTOM_FIELD,
  )?.value?.centAmount || null;

  return centAmountToNormalPrice(last30DaysCentAmount);

};
